import React from 'react';
import './documentosAnexos.scss';

//Componentes
import FileUpload from '../../components/fileUpload';
import NavigationButtons from '../../components/navigationButtons';
import Breadcrumbs from '../../components/breadcrumbs';
import Label from '../../components/label';
import CheckObligation from '../../components/checkObligation';
import Toggle from '../../components/toggle';
import Table from '../../components/table';
import AddItem from '../../components/addItem';
import FormAssociadoPJ from '../../components/formAssociadoPJ';
import tiposSocio from '../../helper/tiposSocio';

class DocumentosAnexos extends React.Component {

  componentWillMount() {
    this.formFields = [];
  }

  render() {

    let {
      documentos_documentoIdentificacaoFrente,
      documentos_documentoIdentificacaoVerso,
      documentos_comprovanteResidenciaComprovante,
      documentos_comprovanteRendaComprovante,
      documentos_procuracaoComprovante,
      documentos_contratoSocialComprovante,
      documentos_balancoPatrimonial,
      documentos_faturamentoUltimosMeses,
      documentos_estatutoPessoaJuridicaNacional,
      documentos_procuracaoPessoaJuridicaEstrangeira,
      listTypeArquivo,
      documentos_documentosAdministradorFlag,
      documentos_documentosSocioPessoaFisicaDezMaisFlag,
      documentos_documentosSocioPessoaFisicaMenosDezFlag,
      documentos_documentosSocioPessoaJuridicaNacionalFlag,
      documentos_documentosSocioPessoaJuridicaEstrangeiraFlag,
      documentos_documentosProcuradorFalg,
      documentosSocioDezOuMais,
      documentosSocioMenosDez
    } = this.props.documentosAnexos;

    let {
      declaracoesEspecificasObrigatorias_operacaoImportacao
    } = this.props.declaracaoEspecifica;

    let {
      handleChangeDocumentosAnexos,
      handleChangeDocumentosAnexosArray,
      dadosIniciais_tipoDocumento,
      handleChangeDocumentosAdministradorValueFlag,
      handleChangeDocumentosSocioPessoaFisicaDezMaisValueFlag,
      handleChangeDocumentosSocioPessoaFisicaMenosDezValueFlag,
      handleChangeDocumentosSocioPessoaJuridicaNacionalValueFlag,
      handleChangeDocumentosSocioPessoaJuridicaEstrangeiraValueFlag,
      handleChangeDocumentosProcuradorValueFlag,
      documentosDeleteFile,
      documentosArrayDeleteFile,
      adicionarSocioDezOuMais,
      adicionarSocioMenosDez
    } = this.props;

    let {
      tipoPessoaValue
    } = this.props.tipoPessoa

    return (
      <section className="container">
        <div className="col">
          <Breadcrumbs />
        </div>
        <div className="col">
          <Label type="title" label="Documentos Básicos" />
        </div>
        <CheckObligation field="documentos_documentoIdentificacaoFrente">
          {(validacoes) =>
            <FileUpload
              name="documentos_documentoIdentificacaoFrente"
              id="documentos_documentoIdentificacaoFrente"
              onChange={handleChangeDocumentosAnexos}
              textFile="Frente do documento de identificação com foto e CPF."
              subText="RG, CNH ou documento de orgão de classe dentro do prazo de validade."
              listTypeArquivo={listTypeArquivo}
              documentType={15}
              imageType={1}
              idGrupoDocumento={7}
              required={validacoes.obrigatorio}
              disable={documentos_documentoIdentificacaoFrente.documents.length > 0}
              onlyOneArchive={true}
              {...documentos_documentoIdentificacaoFrente}
              returnObject={this.createRefFields}
            />}
        </CheckObligation>

        <Table
          list={documentos_documentoIdentificacaoFrente.documents}
          onClick={documentosDeleteFile}
        />

        <CheckObligation field="documentos_documentoIdentificacaoVerso" fieldConditional={{ dadosIniciais_tipoDocumento }}>
          {(validacoes) =>
            <FileUpload
              name="documentos_documentoIdentificacaoVerso"
              id="documentos_documentoIdentificacaoVerso"
              onChange={handleChangeDocumentosAnexos}
              textFile="Verso do documento de identificação e CPF."
              subText="RG, CNH ou documento de orgão de classe dentro do prazo de validade."
              listTypeArquivo={listTypeArquivo}
              {...documentos_documentoIdentificacaoVerso}
              documentType={15}
              imageType={2}
              idGrupoDocumento={7}
              disable={documentos_documentoIdentificacaoVerso.documents.length > 0}
              onlyOneArchive={true}
              required={validacoes.obrigatorio}
              returnObject={this.createRefFields}
            />}
        </CheckObligation>

        <Table
          list={documentos_documentoIdentificacaoVerso.documents}
          onClick={documentosDeleteFile}
        />

        <CheckObligation field="documentos_comprovanteResidenciaComprovante">
          {(validacoes) =>
            <FileUpload
              name="documentos_comprovanteResidenciaComprovante"
              id="documentos_comprovanteResidenciaComprovante"
              onChange={handleChangeDocumentosAnexos}
              textFile={
                  `Comprovante de endereço em nome d${tipoPessoaValue === "PessoaJuridica" ? 'a empresa' : 'o cliente'}.`
              }
              subText="Conta de consumo como água, luz, telefone fixo ou gás, emitido nos últimos 90 dias."
              listTypeArquivo={listTypeArquivo}
              {...documentos_comprovanteResidenciaComprovante}
              documentType={3}
              imageType={4}
              idGrupoDocumento={7}
              required={validacoes.obrigatorio}
              returnObject={this.createRefFields}
            />}
        </CheckObligation>

        <Table
          list={documentos_comprovanteResidenciaComprovante.documents}
          onClick={documentosDeleteFile}
        />

        <CheckObligation field="documentos_comprovanteRendaComprovante">
          {(validacoes) =>
            <FileUpload
              name="documentos_comprovanteRendaComprovante"
              id="documentos_comprovanteRendaComprovante"
              onChange={handleChangeDocumentosAnexos}
              textFile="Comprovante de renda atualizado."
              subText="IRPF do último ano base, últimos 3 contracheques ou DECORE emitido pelo contador."
              listTypeArquivo={listTypeArquivo}
              {...documentos_comprovanteRendaComprovante}
              documentType={7}
              imageType={4}
              idGrupoDocumento={7}
              required={validacoes.obrigatorio}
              returnObject={this.createRefFields}
            />}
        </CheckObligation>

        <Table
          list={documentos_comprovanteRendaComprovante.documents}
          onClick={documentosDeleteFile}
        />

        <CheckObligation field="documentos_contratoSocialComprovante">
          {(validacoes) =>
            <FileUpload
              name="documentos_contratoSocialComprovante"
              id="documentos_contratoSocialComprovante"
              onChange={handleChangeDocumentosAnexos}
              textFile="Estatuto ou Contrato Social atualizado."
              listTypeArquivo={listTypeArquivo}
              {...documentos_contratoSocialComprovante}
              documentType={9}
              imageType={4}
              idGrupoDocumento={7}
              required={validacoes.obrigatorio}
              returnObject={this.createRefFields}
            />}
        </CheckObligation>

        <Table
          list={documentos_contratoSocialComprovante.documents}
          onClick={documentosDeleteFile}
        />

        <CheckObligation field="documentos_balancoPatrimonial">
          {(validacoes) =>
            <FileUpload
              name="documentos_balancoPatrimonial"
              id="documentos_balancoPatrimonial"
              onChange={handleChangeDocumentosAnexos}
              textFile="Último balanço patrimonial/DRE assinado pelo contador e pelo responsável pela empresa."
              subText={(
                "Último Balanço Patrimonial assinado pelo contador e pelo responsável pela empresa ou DEFIS " +
                "(Somente para empresas caraterizadas Simples Nacional) ou Escrituração Contábil Fiscal (ECF) " +
                "e Recibo de Entrega (Somente para empresas na categoria de Lucro Presumido ou Real)."
              )}
              listTypeArquivo={listTypeArquivo}
              {...documentos_balancoPatrimonial}
              documentType={13}
              imageType={4}
              idGrupoDocumento={7}
              required={validacoes.obrigatorio}
              returnObject={this.createRefFields}
            />}
        </CheckObligation>

        <Table
          list={documentos_balancoPatrimonial.documents}
          onClick={documentosDeleteFile}
        />

        <CheckObligation field="documentos_faturamentoUltimosMeses">
          {(validacoes) =>
            <FileUpload
              name="documentos_faturamentoUltimosMeses"
              id="documentos_faturamentoUltimosMeses"
              onChange={handleChangeDocumentosAnexos}
              textFile="Faturamento dos últimos 12 meses assinado pelo contador e pelo responsável pela empresa."
              listTypeArquivo={listTypeArquivo}
              {...documentos_faturamentoUltimosMeses}
              documentType={11}
              imageType={4}
              idGrupoDocumento={7}
              required={validacoes.obrigatorio}
              returnObject={this.createRefFields}
            />}
        </CheckObligation>

        <Table
          list={documentos_faturamentoUltimosMeses.documents}
          onClick={documentosDeleteFile}
        />

        {/*===============================================================            ADMINISTRADOR             ==============================================================================*/}

        <CheckObligation field="documentos_documentosAdministradorFlag">
          {(validacoes) =>
            <div className="col documentos_anexos">
              <div className="col-togle">
                <Toggle id="documentos_documentosAdministradorFlag" check={documentos_documentosAdministradorFlag} onChange={handleChangeDocumentosAdministradorValueFlag} />
              </div>
              <div className="col-togle-p">
                <p>Administrador</p>
              </div>
            </div>}
        </CheckObligation>

        <CheckObligation field="documentos_formAdministrador" fieldConditional={{ documentos_documentosAdministradorFlag }}>
          {(validacoes) => <FormAssociadoPJ tipoSocio={tiposSocio.administrador} />}
        </CheckObligation>

        {/*===============================================================    SOCIO PESSOA FÍSICA 10% OU MAIS   ==============================================================================*/}
           
        {documentosSocioDezOuMais.length === 0 && (
         <CheckObligation field="documentos_documentosSocioPessoaFisicaDezMaisFlag">
         {(validacoes) =>
           <div className="col documentos_anexos">
             <div className="col-togle">
               <Toggle 
                 id={`documentos_documentosSocioPessoaFisicaDezMaisFlag${0}`}
                 check={documentos_documentosSocioPessoaFisicaDezMaisFlag} 
                 onChange={handleChangeDocumentosSocioPessoaFisicaDezMaisValueFlag} 
                 idItem={0}
               />
             </div>
             <div className="col-togle-p">
               <p>Sócio Pessoa Física (que detenha 10% ou mais do capital social)</p>
             </div>
           </div>
          }
        </CheckObligation>    
        )}

        {documentosSocioDezOuMais.map((item, ind) => {
          return (
          <div key={ind}>
            <CheckObligation field="documentos_documentosSocioPessoaFisicaDezMaisFlag">
              {(validacoes) =>
                <div className="col documentos_anexos">
                  <div className="col-togle">
                    <Toggle 
                      id={`documentos_documentosSocioPessoaFisicaDezMaisFlag${item.id}`}
                      check={documentos_documentosSocioPessoaFisicaDezMaisFlag} 
                      onChange={handleChangeDocumentosSocioPessoaFisicaDezMaisValueFlag} 
                      idItem={item.id}
                    />
                  </div>
                  <div className="col-togle-p">
                    <p>Sócio Pessoa Física {ind + 1} (que detenha 10% ou mais do capital social)</p>
                  </div>
                </div>}
            </CheckObligation>

            <CheckObligation field="documentos_formSocioPessoaFisicaDezMais" fieldConditional={{ documentos_documentosSocioPessoaFisicaDezMaisFlag }}>
              {(validacoes) => <FormAssociadoPJ tipoSocio={tiposSocio.socioPFDezMais} idSocio={item.id} />}
            </CheckObligation>
  
          <CheckObligation field="documentos_comprovanteRendaSocioPessoaFisicaDezOuMais" fieldConditional={{ documentos_documentosSocioPessoaFisicaDezMaisFlag, declaracoesEspecificasObrigatorias_operacaoImportacao }}>
            {(validacoes) =>
              <FileUpload
                nameDocs="documentosSocioDezOuMais"
                name={`documentos_comprovanteRendaSocioPessoaFisicaDezOuMais#${item.id}`}
                id={`documentos_comprovanteRendaSocioPessoaFisicaDezOuMais#${item.id}`}
                onChange={handleChangeDocumentosAnexosArray}
                textFile="Comprovante de renda atualizado (IRPF declaração e recibo)."
                subText={`IRPF do último ano base, últimos 3 contracheques ou DECORE emitido pelo contador.\n\nAplicável somente para empresas recém constituídas ou que operam com importação na posição própia da B&T`}
                listTypeArquivo={listTypeArquivo}
                {...item.documentos_comprovanteRendaSocioPessoaFisicaDezOuMais}
                documentType={7}
                imageType={4}
                idGrupoDocumento={4}
                required={validacoes.obrigatorio}
                returnObject={this.createRefFields}
              />}
          </CheckObligation>
  
          <Table
            list={item.documentos_comprovanteRendaSocioPessoaFisicaDezOuMais.documents}
            onClick={documentosArrayDeleteFile}
          />
         </div>)
        })}       

        {documentosSocioDezOuMais.length > 0 && (
          <div>
            <AddItem text="Adicionar Sócio" action={adicionarSocioDezOuMais}/>
          </div>
        )}        

        {/*===============================================================    SOCIO PESSOA FÍSICA MENOS DE 10%   ==============================================================================*/}

        {documentosSocioMenosDez.length === 0 && (
          <CheckObligation field="documentos_documentosSocioPessoaFisicaMenosDezFlag">
            {(validacoes) =>
              <div className="col documentos_anexos">
                <div className="col-togle">
                  <Toggle 
                    id={`documentos_documentosSocioPessoaFisicaMenosDezFlag${0}`} 
                    check={documentos_documentosSocioPessoaFisicaMenosDezFlag} 
                    onChange={handleChangeDocumentosSocioPessoaFisicaMenosDezValueFlag} 
                    idItem={0}
                  />
                </div>
                <div className="col-togle-p">
                  <p>Sócio Pessoa Física (que detenha menos de 10% do capital social)</p>
                </div>
              </div>}
          </CheckObligation>
        )}

        {documentosSocioMenosDez.map((item, ind) => {
          return (
          <div key={ind}>
            <CheckObligation field="documentos_documentosSocioPessoaFisicaMenosDezFlag">
              {(validacoes) =>
                <div className="col documentos_anexos">
                  <div className="col-togle">
                    <Toggle 
                      id={`documentos_documentosSocioPessoaFisicaMenosDezFlag${item.id}`} 
                      check={documentos_documentosSocioPessoaFisicaMenosDezFlag} 
                      onChange={handleChangeDocumentosSocioPessoaFisicaMenosDezValueFlag} 
                      idItem={item.id}
                    />
                  </div>
                  <div className="col-togle-p">
                    <p>Sócio Pessoa Física {ind + 1} (que detenha menos de 10% do capital social)</p>
                  </div>
                </div>}
            </CheckObligation>

            <CheckObligation field="documentos_formSocioPessoaFisicaMenosDez" fieldConditional={{ documentos_documentosSocioPessoaFisicaMenosDezFlag }}>
                  {(validacoes) => <FormAssociadoPJ tipoSocio={tiposSocio.socioPFMenosDez} idSocio={item.id} />}
            </CheckObligation>
         </div>)
        })}  

        {documentosSocioMenosDez.length > 0 && (
          <div>
            <AddItem text="Adicionar Sócio" action={adicionarSocioMenosDez}/>
          </div>
        )}    

        {/*===============================================================  SÓCIO PESSOA JURÍDICA NACIONAL ==============================================================================*/}

        <CheckObligation field="documentos_documentosSocioPessoaJuridicaNacionalFlag">
          {(validacoes) =>
            <div className="col documentos_anexos">
              <div className="col-togle">
                <Toggle id="documentos_documentosSocioPessoaJuridicaNacionalFlag" check={documentos_documentosSocioPessoaJuridicaNacionalFlag} onChange={handleChangeDocumentosSocioPessoaJuridicaNacionalValueFlag} />
              </div>
              <div className="col-togle-p">
                <p>Sócio Pessoa Jurídica Nacional</p>
              </div>
            </div>}
        </CheckObligation>

        <CheckObligation field="documentos_estatutoPessoaJuridicaNacional" fieldConditional={{ documentos_documentosSocioPessoaJuridicaNacionalFlag }}>
          {(validacoes) =>
            <FileUpload
              name="documentos_estatutoPessoaJuridicaNacional"
              id="documentos_estatutoPessoaJuridicaNacional"
              onChange={handleChangeDocumentosAnexos}
              textFile="Estatuto ou Contrato Social atualizado Socia PJ Nacional."
              listTypeArquivo={listTypeArquivo}
              documentType={9}
              imageType={4}
              idGrupoDocumento={6}
              required={validacoes.obrigatorio}
              {...documentos_estatutoPessoaJuridicaNacional}
              returnObject={this.createRefFields}
            />}
        </CheckObligation>

        <Table
          list={documentos_estatutoPessoaJuridicaNacional.documents}
          onClick={documentosDeleteFile}
        />

        {/*===============================================================  SÓCIO PESSOA JURÍDICA ESTRANGEIRA ==============================================================================*/}

        <CheckObligation field="documentos_documentosSocioPessoaJuridicaEstrangeiraFlag">
          {(validacoes) =>
            <div className="col documentos_anexos">
              <div className="col-togle">
                <Toggle id="documentos_documentosSocioPessoaJuridicaEstrangeiraFlag" check={documentos_documentosSocioPessoaJuridicaEstrangeiraFlag} onChange={handleChangeDocumentosSocioPessoaJuridicaEstrangeiraValueFlag} />
              </div>
              <div className="col-togle-p">
                <p>Sócio Pessoa Jurídica Estrangeira</p>
              </div>
            </div>}
        </CheckObligation>

        <CheckObligation field="documentos_procuracaoPessoaJuridicaEstrangeira" fieldConditional={{ documentos_documentosSocioPessoaJuridicaEstrangeiraFlag }}>
          {(validacoes) =>
            <FileUpload
              name="documentos_procuracaoPessoaJuridicaEstrangeira"
              id="documentos_procuracaoPessoaJuridicaEstrangeira"
              onChange={handleChangeDocumentosAnexos}
              textFile="Procuração outorgada ao representante legal no Brasil."
              listTypeArquivo={listTypeArquivo}
              documentType={10}
              imageType={1}
              idGrupoDocumento={5}
              required={validacoes.obrigatorio}
              {...documentos_procuracaoPessoaJuridicaEstrangeira}
              returnObject={this.createRefFields}
            />}
        </CheckObligation>

        <Table
          list={documentos_procuracaoPessoaJuridicaEstrangeira.documents}
          onClick={documentosDeleteFile}
        />

        {/*===============================================================            PROCURADOR             ==============================================================================*/}


        <CheckObligation field="documentos_documentosProcuradorFalg">
          {(validacoes) =>
            <div className="col documentos_anexos">
              <div className="col-togle">
                <Toggle id="documentos_documentosProcuradorFalg" check={documentos_documentosProcuradorFalg} onChange={handleChangeDocumentosProcuradorValueFlag} />
              </div>
              <div className="col-togle-p">
                <p>Possui Procurador?</p>
              </div>
            </div>}
        </CheckObligation>

        <CheckObligation field="documentos_formProcurador" fieldConditional={{ documentos_documentosProcuradorFalg }}>
          {(validacoes) => <FormAssociadoPJ tipoSocio={tiposSocio.procurador} />}
        </CheckObligation>

        <CheckObligation field="documentos_procuracaoComprovante" fieldConditional={{ documentos_documentosProcuradorFalg }}>
          {(validacoes) =>
            <FileUpload
              name="documentos_procuracaoComprovante"
              id="documentos_procuracaoComprovante"
              onChange={handleChangeDocumentosAnexos}
              textFile={
                tipoPessoaValue === "PessoaJuridica" ?
                  "Procuração vigente para executar operações de câmbio e assinar contratos de câmbio" :
                  "Procuração com firma reconhecida."
              }
              listTypeArquivo={listTypeArquivo}
              {...documentos_procuracaoComprovante}
              documentType={8}
              imageType={4}
              idGrupoDocumento={2}
              required={validacoes.obrigatorio}
              returnObject={this.createRefFields}
            />}
        </CheckObligation>

        <Table
          list={documentos_procuracaoComprovante.documents}
          onClick={documentosDeleteFile}
        />


        <div className="col">
          <NavigationButtons history={this.props.history} validateFields={this.validateFields} />
        </div>
      </section>
    );
  }

  createRefFields = (self) => {
    this.formFields[self.props.name] = self
  }

  validateFields = async () => {
    const list = [];
    let countMounted = 0;

    const {
      tipoPessoaValue
    } = this.props.tipoPessoa;

    if (tipoPessoaValue === "PessoaJuridica") {
      const socios = [
        this.props.documentosAnexos.documentos_documentosSocioPessoaFisicaDezMaisFlag,
        this.props.documentosAnexos.documentos_documentosSocioPessoaFisicaMenosDezFlag,
        this.props.documentosAnexos.documentos_documentosSocioPessoaJuridicaNacionalFlag,
        this.props.documentosAnexos.documentos_documentosSocioPessoaJuridicaEstrangeiraFlag,
      ]

      const peloMenosUmSocio = socios.some(s => !!s);
    
      list.push({ name: "documentos_socioObrigatorio", valid: peloMenosUmSocio });

      if (!peloMenosUmSocio) {
        let { setMessageConclusaoAction } = this.props;
        setMessageConclusaoAction({
          icon: "fa-close",
          title: "",
          error: "",
          discription: "Necessária a seleção de ao menos um sócio.",
          isError: true,
        });
      }
    }
      
    return new Promise(resolve => {
      if (Object.keys(this.formFields).length === 0) {
        resolve([])
      }

      if (this.props.loading) {
        return
      }

      for (let key in this.formFields) {
        if (this.formFields[key]._isMounted) {
          countMounted++

          this.formFields[key].validate(this.formFields[key].input)

            // eslint-disable-next-line no-loop-func
            .then(r => {
                list.push({ name: this.formFields[key].props.name, valid: r })

              if (countMounted === list.length) {
                const nomesSocios = Object.entries(tiposSocio);
                for (const ass of this.props.associados) {
                  const nomeAss = nomesSocios.find((n) => n[1] === ass.tipoSocio)[0];
                  if (!ass.done) this.props.warnFormIncompleteAction(ass.tipoSocio);
                  list.push({
                    name: `formAssociado${nomeAss}${ass.idSocio && '#' + ass.idSocio}`,
                    valid: ass.done
                  });
                }
                resolve(list)
              }
            })
            
        }
      }
    })
  }
}

export default DocumentosAnexos;

